module.exports = __webpack_public_path__ + "static/PlutoSansBold-4c7275ea6775844930b40700541dba06.ttf";